<script setup lang="ts">
import PageMeta from "../../components/PageMeta";
import TopLink from "../../components/ui/TopLink.vue";
</script>

<template>
  <PageMeta
    title="Données personnelles, suivi d’audience et vie privée"
    description="Politique de confidentialité des données personnelles du site ara.numerique.gouv.fr"
  />
  <section class="fr-my-0 fr-mx-auto content">
    <h1>Données personnelles, suivi d’audience et vie privée</h1>
    <h2>Données personnelles</h2>
    <h3>Qui est responsable d’Ara ?</h3>
    <p>
      Ara est un outil d’audit d’accessibilité numérique développé au sein la
      direction interministérielle du numérique (DINUM).
    </p>
    <p>
      Le responsable du traitement des données est la DINUM, représentée par
      Stéphanie Schaer, directrice interministérielle du numérique.
    </p>
    <h3>Pourquoi et comment vos données personnelles sont traitées ?</h3>
    <div class="fr-table fr-table--bordered fr-table--no-caption">
      <div class="fr-table__wrapper">
        <div class="fr-table__container">
          <div class="fr-table__content">
            <table class="fr-cell--multiline">
              <caption>
                Traitement des données personnelles
              </caption>
              <thead>
                <tr>
                  <th scope="col">Données</th>
                  <th scope="col">Finalité poursuivie</th>
                  <th scope="col">Fondement juridique</th>
                  <th scope="col">Durée de conservation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Adresse électronique</td>
                  <td>
                    Permettre la création de compte. <br />Transmettre par
                    courriel les URL liées à l’audit
                  </td>
                  <td>
                    Mission d’intérêt public relevant de la compétence de la
                    DINUM (article 6 – 5° du décret n<sup>o</sup> 2019-1088 du
                    25 octobre 2019)
                  </td>
                  <td rowspan="2">
                    L’utilisateur·rice peut supprimer son compte et ses données
                    personnelles à tout moment.<br />
                    Un compte inactif pendant 5 ans est automatiquement supprimé
                    ainsi que les données personnelles de l'utilisateur·rice.
                    Les audits associés sont alors anonymisés.<br />
                    Les audits réalisés sans compte sont automatiquement
                    anonymisés après 5 ans et les données personnelles de
                    l'utilisateur·rice supprimées.
                  </td>
                </tr>
                <tr>
                  <td>Prénom et nom</td>
                  <td>« Signer » le rapport d’accessibilité</td>
                  <td>Intérêt légitime</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <h3>Qui nous aide à traiter vos données personnelles ?</h3>
    <p>
      Afin d’héberger vos données personnelles, nous faisons appel à un
      sous-traitant. Avant de lui transmettre vos données, nous nous sommes
      assurés de la mise en œuvre par ses sous-traitants de garanties adéquates
      et du respect de conditions strictes de confidentialité, d’usage et de
      protection des données.
    </p>
    <div class="fr-table fr-table--bordered fr-table--no-caption">
      <div class="fr-table__wrapper">
        <div class="fr-table__container">
          <div class="fr-table__content">
            <table class="fr-cell--multiline">
              <caption>
                Partenaire traitant les données personnelles
              </caption>
              <thead>
                <tr>
                  <th scope="col">Partenaire</th>
                  <th scope="col">Pays destinataire</th>
                  <th scope="col">Traitement réalisé</th>
                  <th scope="col">Garanties</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>OVH</td>
                  <td>France</td>
                  <td>Stockage des données en base de données</td>
                  <td>Clauses de sous-traitance</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <h3>Quels sont vos droits ?</h3>
    <p>Vous disposez :</p>
    <ul>
      <li>d’un droit d’information et d’un droit d’accès à vos données ;</li>
      <li>d’un droit à la limitation du traitement de vos données ;</li>
      <li>d’un droit de rectification ;</li>
      <li>d’un droit d’opposition.</li>
    </ul>
    <p>
      Pour les exercer, contactez-nous par message électronique : dpd@pm.gouv.fr
    </p>
    <p>Ou par voie postale à l’adresse suivante :</p>
    <p>
      Services du Premier ministre<br />
      À l’attention du délégué à la protection des données (DPD)<br />
      56 rue de Varenne<br />
      75007 Paris
    </p>
    <p>
      Puisque ce sont des droits personnels, nous ne traiterons votre demande
      que si nous sommes en mesure de vous identifier. Dans le cas où nous ne
      parvenons pas à vous identifier, nous pouvons être amenés à vous demander
      une preuve de votre identité.
    </p>
    <p>
      Pour vous aider dans votre démarche, vous trouverez un modèle de demande
      élaboré par la CNIL ici :
      <a href="https://www.cnil.fr/fr/modele/courrier/exercer-son-droit-dacces">www.cnil.fr/fr/modele/courrier/exercer-son-droit-dacces</a>.
    </p>
    <p>
      Nous nous engageons à vous répondre dans un délai raisonnable qui ne
      saurait dépasser 1 mois à compter de la réception de votre demande.
    </p>

    <h2>Suivi d’audience et vie privée</h2>
    <h3>Cookies déposés et <span lang="en">opt-out</span></h3>
    <p>
      Ce site dépose un petit fichier texte (un « cookie ») sur votre appareil
      lorsque vous le consultez. Cela nous permet de mesurer le nombre de
      visites et de comprendre quelles sont les pages les plus consultées.
    </p>

    <h3>
      Ce site n’affiche pas de bannière de consentement aux cookies, pourquoi ?
    </h3>
    <p>
      Nous respectons simplement la loi, qui dit que certains outils de suivi
      d’audience, correctement configurés pour respecter la vie privée, sont
      exemptés d’autorisation préalable.
    </p>
    <p>
      Nous utilisons pour cela Matomo, un outil libre, paramétré pour être en
      conformité avec la recommandation « Cookies » de la CNIL. Cela signifie
      que votre adresse IP, par exemple, est anonymisée avant d’être
      enregistrée. Il est donc impossible d’associer vos visites sur ce site à
      votre personne.
    </p>

    <h3>Je contribue à enrichir vos données, puis-je y accéder ?</h3>
    <p class="fr-mb-0">
      Bien sûr ! Les statistiques d’usage sont disponibles en accès libre sur
      <a href="https://stats.data.gouv.fr/">stats.data.gouv.fr</a>.
    </p>
    <div class="top-link">
      <TopLink />
    </div>
  </section>
</template>

<style scoped>
.content {
  max-width: 49.5rem;
}

.top-link {
  text-align: end;
}
</style>
